import { NextRequest } from 'next/server';
const getHost = (ctx: ApiOrSsrReqContext | undefined, req?: NextRequest) => {
  const hostName = ctx?.req.headers.host || req?.nextUrl.host || '';
  if (hostName === 'source.meeting.qq.com') {
    return 'meeting.tencent.com';
  }
  return hostName;
};

export default getHost;
